module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/artillery-strike-cancel.efaf3154.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/artillery-strike-cancel.png
// module id = 3731
// module chunks = 11